import * as UnlockConstants from '../constants';

const initialState = {
  challengeAnswer: '',
  obfuscatedChallenge: '',
  challengeFields: [],
  errorMessage: null,
  isFetching: false,
  isSubmitting: false
};

export function unlock(state = initialState, action) {
  switch (action.type) {
    case UnlockConstants.CHALLENGE_FETCH_STARTED:
      return Object.assign({}, state, {isFetching: true});
    case UnlockConstants.CHALLENGE_FETCH_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        obfuscatedChallenge: action.obfuscatedChallenge,
        challengeFields: action.challengeFields
      });
    case UnlockConstants.CHALLENGE_ANSWER_SUBMIT_STARTED:
      return Object.assign({}, state, {isSubmitting: true});
    case UnlockConstants.CHALLENGE_ANSWER_SUBMIT_COMPLETED:
      return Object.assign({}, state, {errorMessage: null, isSubmitting: false, isFetching: false});
    case UnlockConstants.CHALLENGE_ANSWER_SUBMIT_ERROR:
      return Object.assign({}, state, {isSubmitting: false, isFetching: false, errorMessage: action.errorMessage});
    default:
      return state;
  }
}
